export default __webpack_public_path__ + "static/hero_2-aba5cbf66a119c82d0721b048a594d0e.png";